import { useState, useEffect } from "react";

import InputLabel from "./InputLabel";

const SelectBox = ({ label, options, selectedOption, onChange, className }) => {
  const [selected, setSelected] = useState(selectedOption || options[0]);

  useEffect(() => {
    setSelected(selectedOption);
  }, [selectedOption]);

  const handleChange = (option) => {
    const { value } = option;
    setSelected(value);
    onChange(option);
  };

  return (
    <div className={`flex flex-col items-start w-full ${className || ""}`}>
      <InputLabel className="mr-2">{label}</InputLabel>
      <div className="flex flex-wrap gap-3">
        {options.map((option) => (
          <button
            className={`rounded-full text-center px-5 py-4 font-bold text-700 ${selected === option.value ? "bg-primary text-white" : "bg-bg1"}`}
            key={option.value}
            onClick={() => handleChange(option)}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SelectBox;
